import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IdentityConfigurationService } from '@auth';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    private identityConfigService: IdentityConfigurationService = inject(IdentityConfigurationService);

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        //const authToken = this.auth.getAuthorizationToken();
        const client = this.identityConfigService.getClient();
        const product = this.identityConfigService.getProduct();
        const service = req.headers.has('x-service')
            ? req.headers.get('x-service')!
            : this.identityConfigService.getService();

        let newReq = req.clone({
            headers: req.headers.set('x-client', client)
                .set('x-product', product)
                .set('x-service', service)
                .set('Accept-Language', localStorage.getItem('lng') ?? 'en')
        })

        return next.handle(newReq);
    }
}
